import React from "react";
import { Modal, Button } from "react-bootstrap";
import dayjs from "dayjs";

/**
 * Modal shown when a student books a class whose topic they already studied.
 * Non-blocking by default (blocked=false); pass blocked=true when
 * AcademyPolicy.allow_topic_repeat=false to disable the confirm button.
 *
 * Props:
 *   topicName  — topic the student already took
 *   lastDate   — ISO date string of the previous class
 *   lastScore  — numeric score from the previous class
 *   blocked    — if true, the confirm button is disabled
 *   onConfirm  — called when the student chooses to book anyway
 *   onCancel   — called when the student cancels
 */
function TopicRepeatAlert({ topicName, lastDate, lastScore, blocked, onConfirm, onCancel }) {
  const formattedDate = lastDate ? dayjs(lastDate).format("DD/MM/YYYY") : "";

  return (
    <Modal show onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Tema ya cursado</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Ya cursaste <strong>{topicName}</strong> el{" "}
          <strong>{formattedDate}</strong> con nota{" "}
          <strong>{lastScore}</strong>.
        </p>
        {blocked ? (
          <p className="text-danger mb-0">
            La academia no permite repetir este tema.
          </p>
        ) : (
          <p className="text-muted mb-0">¿Agendar de todos modos?</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} style={{ minHeight: 44 }}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={blocked}
          style={{ minHeight: 44 }}
        >
          Agendar de todos modos
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export { TopicRepeatAlert };
